module.exports = __webpack_public_path__ + "img/上方帘子.6a44a735.png";